<div class="course-structure">
  <!-- <div class="course-structure__header">
    <h2 class="course-structure__title">
      {{ 'app.components.courseDetail.structure.title' | translate }}
    </h2>
  </div> -->
  <div class="course-structure__list">
    @for (task of tasks(); track task.id; let i = $index) {
      <button
        type="button"
        class="course-structure__item"
        [class.course-structure__item--completed]="isTaskCompleted(task)"
        [class.course-structure__item--selected]="isTaskSelected(task)"
        [class.course-structure__item--disabled]="tasksDisabled()"
        [disabled]="tasksDisabled()"
        (click)="onTaskClick(task, $event)"
      >
        <div class="course-structure__item-number">{{ task.orderIndex || i + 1 }}</div>
        @if (task.coverUrl || task.thumbnailUrl) {
          <div class="course-structure__item-thumb">
            <img
              [src]="task.coverUrl || task.thumbnailUrl"
              [alt]="task.title || task.name || ''"
              class="course-structure__item-thumb-img"
            />
          </div>
        }
        <div class="course-structure__item-content">
          <div class="course-structure__item-title">{{ task.title || task.name || ('app.components.courseCreator.publish.lessonsInformation.lessonName' | translate) }}</div>
          @if (task.description) {
            <div class="course-structure__item-desc">{{ task.description }}</div>
          }
        </div>
        <div class="course-structure__item-meta">
          @if (task.estimatedTime) {
            <span class="course-structure__item-duration">{{ formatDuration(task.estimatedTime) }}</span>
          }
        </div>
      </button>
    }
  </div>
  @if (tasks().length === 0) {
    <div class="course-structure__empty">
      {{ 'app.components.courseDetail.structure.empty' | translate }}
    </div>
  }
</div>
